import React from 'react'
import { useParams } from 'react-router-dom'
import PageTitle from '../components/title/PageTitle'
import FeaturesHero from '../components/FeaturesHero'
import FeaturesBenefits from '../components/FeaturesBenefits'
import FeaturesBlocks from '../components/FeaturesBlocks'
import FeaturesCta from '../components/FeaturesCta'
import FeaturesUseCase from '../components/FeaturesUseCase'
import FeaturesRelated from '../components/FeaturesRelated'
import FaqSection from '../components/FaqSection'
import JumbotronCover from '../components/JumbotronCover'
import { FEATURE_PAGES, FEATURE_PAGE_MAP } from '../data/featurePages'
import RelatedBranchImage from '../assets/images/features/related/related_branch.png'
import RelatedEmailImage from '../assets/images/features/related/related_email.png'
import RelatedFeedbackImage from '../assets/images/features/related/related_feedback.png'
import RelatedFormsImage from '../assets/images/features/related/related_forms.png'
import RelatedDepartmentImage from '../assets/images/features/related/related_department.png'

const RELATED_FEATURE_IMAGES = {
  branches: RelatedBranchImage,
  'email-campaign': RelatedEmailImage,
  feedback: RelatedFeedbackImage,
  forms: RelatedFormsImage,
  department: RelatedDepartmentImage,
}

const RELATED_FEATURE_CONTENT = {
  forms: {
    title: 'Forms',
  },
  branches: {
    title: 'Branch',
  },
  'email-campaign': {
    title: 'Email Campaign',
  },
  feedback: {
    title: 'Feedback',
  },
  department: {
    title: 'Departments',
  },
}

const FEATURE_PAGE_BOTTOM_CTA = {
  feedback: {
    title: 'Start acting on customer feedback, not guessing',
    ctaPrimary: 'Book a Demo',
    ctaSecondary: 'Start free',
  },
  branches: {
    title: 'Branch-level visibility, without the reporting stress.',
    ctaPrimary: 'Book a Demo',
    ctaSecondary: 'Start free',
  },
  'email-campaign': {
    title: 'Send emails that actually drive satisfaction',
    ctaPrimary: 'Book a Demo',
    ctaSecondary: 'Start free',
  },
  forms: {
    title: 'Powerful Forms Built for Real-World Data Collection',
    ctaPrimary: 'Book a Demo',
    ctaSecondary: 'Start free',
  },
  department: {
    title: 'Bring structure and accountability to every ticket',
    ctaPrimary: 'Book a Demo',
    ctaSecondary: 'Start free',
  },
}

const Features = () => {
  const { featureSlug } = useParams()
  const selectedFeature = FEATURE_PAGE_MAP[featureSlug] || FEATURE_PAGE_MAP.feedback
  const bottomCta = FEATURE_PAGE_BOTTOM_CTA[selectedFeature.slug] || FEATURE_PAGE_BOTTOM_CTA.feedback
  const relatedItems = FEATURE_PAGES
    .filter((feature) => feature.slug !== selectedFeature.slug)
    .slice(0, 4)
    .map((feature) => ({
      title: RELATED_FEATURE_CONTENT[feature.slug]?.title || feature.name,
      description: RELATED_FEATURE_CONTENT[feature.slug]?.description || feature.hero.description,
      href: `/features/${feature.slug}`,
      image: {
        src: RELATED_FEATURE_IMAGES[feature.slug],
        alt: `${RELATED_FEATURE_CONTENT[feature.slug]?.title || feature.name} related feature preview`,
      },
    }))

  return (
    <div>
      <PageTitle title={`${selectedFeature.name} Features | Clientshot Website `} />
      <FeaturesHero content={selectedFeature.hero} />

      <FeaturesBenefits content={selectedFeature.benefits} />
      <FeaturesBlocks content={selectedFeature.blocks} />
      <FeaturesCta content={selectedFeature.cta} />
      <FeaturesUseCase content={selectedFeature.useCases} />
      <FeaturesRelated
        content={{
          title: 'Related features',
          subtitle: 'Explore more feature pages',
          viewAllHref: '/features',
          items: relatedItems,
        }}
      />
      <JumbotronCover
        title={bottomCta.title}
        description={bottomCta.description}
        primaryAction={{
          label: bottomCta.ctaPrimary,
          href: 'https://calendly.com/clientshot1/demo-call',
          external: true,
        }}
        secondaryAction={{
          label: bottomCta.ctaSecondary,
          href: 'https://app.clientshot.com/sign-up',
          external: true,
        }}
      />
      <FaqSection content={selectedFeature.faq} />
    </div>
  )
}

export default Features
